import { clock, dayOf } from '../playback/time';

/** "30/09/2026 10:00:00–10:30:00", or both dates when the range spans days. */
export function formatRange(fromIso: string, toIso: string, timeZone: string | undefined): string {
  const a = Date.parse(fromIso);
  const b = Date.parse(toIso);
  const date = (t: number) => dayOf(t, timeZone).split('-').reverse().join('/');
  return dayOf(a, timeZone) === dayOf(b - 1, timeZone)
    ? `${date(a)} ${clock(a, timeZone)}–${clock(b, timeZone)}`
    : `${date(a)} ${clock(a, timeZone)} → ${date(b)} ${clock(b, timeZone)}`;
}
